import { isCanUseCallSettings } from 'util/getCallType';
import { syncCallSettingsApi } from 'features/AccessRequests/api/accessRequestsApi';
import { isCallInitiator } from 'features/AccessRequests/utils/canBypassWaitingRoom';
import { callPolicyStore } from 'state/store';
import {
    clearCallPolicySession,
    getRestoredCallPolicyDraftFromSession,
    hasPendingPrejoinCallPolicySync,
} from './session';

/** Отправить на сервер правки политики с prejoin, когда есть conference JWT. */
export const syncPrejoinCallPolicyIfNeeded = async (jwtToken: string | null | undefined): Promise<boolean> => {
    if (!jwtToken || !isCanUseCallSettings() || !isCallInitiator() || !hasPendingPrejoinCallPolicySync()) {
        return false;
    }

    // Читаем из session, а не из callPolicyStore — store мог быть перезаписан
    // syncCallPolicyDraftFromServer до того как сюда дошли (например в updateRoomMetadata).
    const draft = getRestoredCallPolicyDraftFromSession();
    if (!draft) {
        return false;
    }

    const { hasError } = await syncCallSettingsApi({
        ...draft,
        jwtToken,
        isLocalGuest: false,
    });

    if (!hasError) {
        // Обновляем store, затем полностью очищаем prejoin-сессию политики.
        // Важно: нельзя оставлять bootstrap в сессии после входа в комнату —
        // иначе hasPendingPrejoinCallPolicySync будет возвращать true при
        // любом изменении в комнате (store ≠ bootstrap → "откат" к преджоин значению).
        callPolicyStore.set(draft);
        clearCallPolicySession();
        return true;
    }

    return false;
};
